import axios from 'axios';

const state = {
    all: [],
    slugs: [],
    loaded: false
};

const getters = {
    hasRole: (state) => (permissoes) => {
        let acesso = false;

        if(Array.isArray(permissoes)) {

            permissoes.forEach((permissao) => {
                if (state.slugs.includes(permissao))
                {
                    acesso = true;
                }
            });

        } else {

            if (state.slugs.includes(permissoes))
            {
                acesso = true;
            }
        }

        return acesso;
    },
};

const actions = {
    populateRoles ({ commit, dispatch }) {
        axios.get(_ROOT_PATH + '/api/permissoes').then((data) => {
            commit('setRoles', data.data.data);
            dispatch('populateSlugs');
        });
    },
    populateSlugs ({ commit, state }) {
        let slugs = state.all.map((role) => {
            return role.slug;
        });
        commit('setSlugs', slugs);
    }
};

const mutations = {
    setRoles (state, permissoes) {
        state.all = permissoes;
        state.loaded = true;
    },
    setSlugs (state, slugs) {
        state.slugs = slugs;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}